import axios from "axios";
import { clearLogoutData } from "../logout/action";
import {
  getpartnerSidebarError,
  getpartnerSidebarSuccess,
} from "../PartnerSidebar/PartnerSidebarAction";
import { Partner_Service_URL } from "../Url";

export const nextPageActions = {
  NEXT_PAGE_LOADING: "NEXT_PAGE_LOADING",
  NEXT_PAGE_SUCCESS: "NEXT_PAGE_SUCCESS",
  NEXT_PAGE_ERROR: "NEXT_PAGE_ERROR",
};

export const nextPage = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { data, partnerFirmId } = props;

  dispatch(nextPageLoading());
  return axios({
    method: "post",
    url: `${Partner_Service_URL}/savePartnerStatus`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    data,
    params: {
      partnerFirmId,
    },
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(nextPageSuccess(response.data));
        dispatch(getpartnerSidebarSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(nextPageError(error));
        // dispatch(getpartnerSidebarError(error));
        throw error;
      }
    })
    .catch((err) => {
      if (err.response) {
        dispatch(nextPageError(err));
        // dispatch(getpartnerSidebarError(err));
        return err.response;
      }
    });
};

export function nextPageError(error) {
  return {
    type: nextPageActions.NEXT_PAGE_ERROR,
    payload: error,
  };
}

export function nextPageSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: nextPageActions.NEXT_PAGE_SUCCESS,
      payload: props,
    });
  };
}

export function nextPageLoading() {
  return {
    type: nextPageActions.NEXT_PAGE_LOADING,
  };
}
